export default {
  namespaced: true,
  state: {
    infoPlanilla: null
  },
  mutations: {
    setInfoPlanilla(state, data) {
      state.infoPlanilla = data;
    },
    updateInfoPlanilla(state, { field, value }) {
      if (state.infoPlanilla) {
        state.infoPlanilla = {
          ...state.infoPlanilla,
          [field]: value
        };
      }
    },
    clearInfoPlanilla(state) {
      state.infoPlanilla = null;
    }
  },
  actions: {}
};

